      	var datosMonedas={"ar":{"info":{"nombre":"Argentina"},"moneda":{"$1":20,"$2":21.5,"$5":23,"$10":24.5},"medida":{"14.0":"4","14.3":"5","14.6":"6","15.0":"7","15.3":"8","15.6":"9","15.9":"10","16.2":"11","16.5":"12","16.8":"13","17.2":"14","17.5":"15","17.8":"16","18.1":"17","18.4":"18","18.8":"19","19.1":"20","19.4":"21","19.7":"22","20.0":"23","20.3":"24","20.6":"25","21.0":"26","21.3":"27"}},"br":{"info":{"nombre":"Brasil"},"moneda":{"0.25R$":25,"0.5R$":23,"1R$":27},"medida":{"14.0":"4","14.3":"5","15.0":"7","15.3":"8","15.6":"9","15.9":"10","16.2":"11","16.5":"12","16.8":"13","17.2":"14","17.5":"15","17.8":"16","18.1":"17","18.4":"18","18.8":"19","19.1":"20","19.4":"21","19.7":"22","20.0":"23","20.3":"24","20.6":"25","21.0":"26","21.3":"27"}},"cl":{"info":{"nombre":"Chile"},"moneda":{"$50":25,"$100":23.5,"$500":26},"medida":{"14.0":"4","14.3":"5","14.6":"6","15.0":"7","15.3":"8","15.6":"9","15.9":"10","16.2":"11","16.5":"12","16.8":"13","17.2":"14","17.5":"15","17.8":"16","18.1":"17","18.4":"18","18.8":"19","19.1":"20","19.4":"21","19.7":"22","20.0":"23","20.3":"24","20.6":"25","21.0":"26","21.3":"27","21.6":"28","22.0":"29"}},"co":{"info":{"nombre":"Colombia"},"moneda":{"$50":17,"$100":20.3,"$200":22.4,"$500":23.7,"$1000":26.7},"medida":{"14.9":"4","15.7":"5","16.5":"6","17.3":"7","18.1":"8","18.8":"9","19.8":"10","20.6":"11","21.3":"12","22.3":"13","23.2":"14","23.9":"15"}},"es":{"info":{"nombre":"Espa&ntilde;a"},"moneda":{"1ct":16.25,"2cts":18.75,"5cts":21.25,"10cts":19.75,"20cts":22.25,"50cts":24.25,"1\u20ac":23.25,"2\u20ac":25.75},"medida":{"14.0":"4","14.3":"5","14.6":"6","15.0":"7","15.3":"8","15.6":"9","15.9":"10","16.2":"11","16.5":"12","16.8":"13","17.2":"14","17.5":"15","17.8":"16","18.1":"17","18.4":"18","18.8":"19","19.1":"20","19.4":"21","19.7":"22","20.0":"23","20.3":"24","20.6":"25","21.0":"26","21.3":"27","21.6":"28","22.0":"29","22.3":"30","22.6":"31"}},"fr":{"info":{"nombre":"Francia"},"moneda":{"1ct":16.25,"2cts":18.75,"5cts":21.25,"10cts":19.75,"20cts":22.25,"50cts":24.25,"1\u20ac":23.25,"2\u20ac":25.75},"medida":{"14.0":"44","14.3":"45","14.6":"46","15.0":"47","15.3":"48","15.6":"49","15.9":"50","16.2":"51","16.5":"52","16.8":"53","17.2":"54","17.5":"55","17.8":"56","18.1":"57","18.4":"58","18.8":"59","19.1":"60","19.4":"61","19.7":"62","20.0":"63","20.3":"64","20.6":"65","21.0":"66","21.3":"67","21.6":"68","22.0":"69","22.3":"70","22.6":"71"}},"it":{"info":{"nombre":"Italia"},"moneda":{"1ct":16.25,"2cts":18.75,"5cts":21.25,"10cts":19.75,"20cts":22.25,"50cts":24.25,"1\u20ac":23.25,"2\u20ac":25.75},"medida":{"14.0":"4","14.3":"5","14.6":"6","15.0":"7","15.3":"8","15.6":"9","15.9":"10","16.2":"11","16.5":"12","16.8":"13","17.2":"14","17.5":"15","17.8":"16","18.1":"17","18.4":"18","18.8":"19","19.1":"20","19.4":"21","19.7":"22","20.0":"23","20.3":"24","20.6":"25","21.0":"26","21.3":"27","21.6":"28","22.0":"29","22.3":"30"}},"mx":{"info":{"nombre":"M\u00e9xico"},"moneda":{"10cts":14,"20cts":15.3,"50cts":17,"$1":21,"$2":23,"$5":25.5,"$10":28},"medida":{"14.0":"3","14.4":"3.5","14.8":"4","15.3":"4.5","15.7":"5","16.1":"5.5","16.5":"6","17.0":"6.5","17.3":"7","17.7":"7.5","18.1":"8","18.6":"8.5","19.0":"9","19.3":"9.5","19.8":"10","20.2":"10.5","20.6":"11","21.0":"11.5","24.4":"12","21.8":"12.5","22.2":"13","22.6":"13.5","23.2":"14","23.5":"14.5","23.9":"15"}},"pe":{"info":{"nombre":"Per\u00fa"},"moneda":{"10ct":20.5,"20ct":23,"50ct":22,"1 sol":25.5,"2 soles":22.3},"medida":{"14.0":"4","14.3":"5","14.6":"6","15.0":"7","15.3":"8","15.6":"9","15.9":"10","16.2":"11","16.5":"12","16.8":"13","17.2":"14","17.5":"15","17.8":"16","18.1":"17","18.4":"18","18.8":"19","19.1":"20","19.4":"21","19.7":"22","20.0":"23","20.3":"24","20.6":"25","21.0":"26","21.3":"27","21.6":"28"}},"pt":{"info":{"nombre":"Portugal"},"moneda":{"1ct":16.25,"2cts":18.75,"5cts":21.25,"10cts":19.75,"20cts":22.25,"0,50\u20ac":24.25,"1\u20ac":23.25,"2\u20ac":25.75},"medida":{"14.0":"4","14.3":"5","14.6":"6","15.0":"7","15.3":"8","15.6":"9","15.9":"10","16.2":"11","16.5":"12","16.8":"13","17.2":"14","17.5":"15","17.8":"16","18.1":"17","18.4":"18","18.8":"19","19.1":"20","19.4":"21","19.7":"22","20.0":"23","20.3":"24","20.6":"25","21.0":"26","21.3":"27","21.6":"28","22.0":"29","22.3":"30","22.6":"31"}},"us":{"info":{"nombre":"U.S.A."},"moneda":{"quarter":24.26},"medida":{"14.0":"3","14.4":"3.5","14.8":"4","15.2":"4.5","15.6":"5","16.0":"5.5","16.5":"6","16.9":"6.5","17.3":"7","17.7":"7.5","18.2":"8","18.6":"8.5","19.0":"9","19.4":"9.5","19.8":"10","20.2":"10.5","20.6":"11","21.0":"11.5","21.4":"12","21.8":"12.5","22.2":"13","22.6":"13.5"}},"uk":{"info":{"nombre":"U.K."},"moneda":{"1p":20.3,"2p":25.9,"5p":18,"10p":24.5,"20p":21.2,"50p":27.3},"medida":{"12.04":"A","12.45":"B","12.85":"C","13.26":"D","13.67":"E","14.07":"F","14.48":"G","14.88":"H","15.29":"I","15.49":"J","15.90":"K","16.31":"L","16.71":"M","17.12":"N","17.53":"O","17.93":"P","18.34":"Q","18.75":"R","19.15":"S","19.56":"T","19.96":"U","20.37":"V","20.78":"W","21.18":"X","21.59":"Y","21.79":"Z"}},"in":{"info":{"nombre":"India"},"moneda":{"\u20b95":23,"\u20b910":27,"\u20b920":27},"medida":{"13.3":"2","13.7":"3","13.9":"4","14.3":"5","14.7":"6","15.1":"7","15.3":"8","15.5":"9","15.9":"10","16.3":"11","16.9":"13","17.3":"14","17.5":"15","17.9":"16","18.1":"17","18.5":"18","18.7":"19","19.1":"20","19.3":"21","19.7":"22","19.9":"23","20.4":"24","20.6":"25","21.0":"26","21.4":"27","21.6":"28","22.0":"29","22.2":"30"}}};
      	var lang={"Portugal":"Portugal","U.S.A.":"U.S.A.","U.K.":"U.K.","Colombia":"Colombia","India":"India","Per\u00fa":"Per\u00fa","M\u00e9xico":"M\u00e9xico","Italia":"Italia","Francia":"Francia","Espa&ntilde;a":"Espa&ntilde;a","Chile":"Chile","Brasil":"Brasil","Argentina":"Argentina","Medidor de anillos":"Medidor de anillos","\u00a1Descubrir la talla de tu anillo es r\u00e1pido y divertido!":"\u00a1Descubrir la talla de tu anillo es r\u00e1pido y divertido!","Selecciona tu pa\u00eds":"Selecciona tu pa\u00eds","Selecciona una opci\u00f3n":"Selecciona una opci\u00f3n","Selecciona una moneda (nos ayudar\u00e1 a calibrar tu pantalla)":"Selecciona una moneda (nos ayudar\u00e1 a calibrar tu pantalla)","Selecciona una moneda":"Selecciona una moneda","Empezar":"Empezar","Calibra tu pantalla":"Calibra tu pantalla","Coloca el anillo":"Coloca el anillo","Descubre tu talla":"Descubre tu talla","Vamos a calibrar tu pantalla":"Vamos a calibrar tu pantalla","\u00a1Hecho!":"\u00a1Hecho!","Coloca una moneda de":"Coloca una moneda de ","en el c\u00edrculo y aj\u00fastalo hasta que tengan el mismo tama\u00f1o.":"por encima del c\u00edrculo rojo y aj\u00fastalo hasta que tengan el mismo tama\u00f1o (la moneda tendr\u00e1 que quedarse dentro de las flechitas negras)","Coloca el anillo sobre el c\u00edrculo":"Coloca el anillo sobre el c\u00edrculo","mensaje_campos_requeridos":"Debes rellenar todos los campos","Mueve el deslizador hasta que la imagen coincida con el di\u00e1metro interior de tu anillo":"Mueve el deslizador hasta que la imagen coincida con el di\u00e1metro interior de tu anillo","Tu talla es":"Tu talla es","\u00a1Recuerda! Si est\u00e1s indeciso entre dos tallas, elige la m\u00e1s grande":"\u00a1Consejo! La medici\u00f3n visual puede tener un margen de error. Si est\u00e1s indeciso entre dos tallas, elige la m\u00e1s grande.","Encuentra el anillo ideal":"Encuentra el anillo ideal","Atr\u00e1s":"Atr\u00e1s","url":"https:\/\/www.matrimonio.com.pe\/joyerias?utm_source=matrimonio.com.pe&utm_campaign=ring_sizer&utm_content=cta_editorial"};

        "use strict";

      window.onload = function inicialza() {
        var medidaEnMmMin = 9900;
        var medidaEnMmMax = 0;

        function muestraModal(texto) {
          var modal = document.getElementById("myModal");
          var span = document.getElementsByClassName("close")[0];
          var textomodal = document.getElementsByClassName("texto_modal")[0];
          textomodal.innerHTML = textomodal.getAttribute("data-".concat(texto));
          modal.style.display = "block";

          span.onclick = function cierraAlClicar() {
            modal.style.display = "none";
          };

          window.onclick = function cierraAlClicarWindows(event) {
            if (event.target === modal) {
              modal.style.display = "none";
            }
          };
        }

        function checkcampos(pagina) {
          if (pagina === "pagina_dos") {
            if (document.getElementById("pais_seleccionado").value !== "" && document.getElementById("moneda_seleccionada").value !== "") {
              var sel = document.getElementById("moneda_seleccionada");
              var moneda = sel.options[sel.selectedIndex].text;
              document.getElementById("moneda_elegida").innerHTML = moneda;
              var target = document.getElementById("slider");
              var min = target.min;
              var max = target.max;
              var val = target.value;
              target.style.backgroundSize = "".concat((val - min) * 100 / (max - min), "% 100%");
              return true;
            }
          }

          if (pagina === "pagina_tres") {
            return true;
          }

          if (pagina === "pagina_uno") {
            return true;
          }

          return pagina === "pagina_final";
        }
        /* NAVEGACION */


        var botonesNavegacionatras = document.getElementsByClassName("atras");

        for (var i = 0; i < botonesNavegacionatras.length; i += 1) {
          var botonesNavegacionAtrasItem = botonesNavegacionatras[i];

          botonesNavegacionAtrasItem.onclick = function iniciapaginas() {
            var paises = document.getElementById("pais").value;
            var monedaSeleccionada = document.getElementById("moneda_seleccionada").value;
            window.location.href = "anillos.php?lang=".concat(paises, "&pais=").concat(paises, "&ms=").concat(monedaSeleccionada, "&ps=").concat(paises);
          };
        }

        var botonesNavegacion = document.getElementsByClassName("boton_navegacion");

        for (var _i = 0; _i < botonesNavegacion.length; _i += 1) {
          var botonesNavegacionItem = botonesNavegacion[_i];

          botonesNavegacionItem.onclick = function recorrepaginas() {
            var paginaDestino = this.dataset.next;
            var error = 0;

            if (checkcampos(this.dataset.next)) {
              error = 0;
            } else {
              error = 1;
            }

            if (error === 0) {
              document.querySelectorAll(".pagina").forEach(function (paginaItem) {
                paginaItem.classList.remove('active');
              });
              document.getElementById(paginaDestino).classList.add("active");

              if (this.dataset.paso === "3") {
                document.getElementById("slider_anillo").style.visibility = "visible";
                document.getElementById("indicaciones_pregunta_grande").style.visibility = "visible";
                document.getElementById("explicacion_instrucciones").style.display = "block";
                document.getElementById("medida_circulo_anillo").style.display = "block";
              }

              if (document.getElementById("medida_circulo_anillo_div").offsetWidth > document.getElementById("medida_circulo_anillo").offsetWidth) {//  document.getElementById("medida_circulo_anillo_div").style.display='none';
              } else {
                document.getElementById("medida_circulo_anillo_div").style.display = 'inline-block';
              }

              //window.parent.AdjustIframeHeight();
            } else {
              muestraModal('requeridos');
            }
          };
        }

        var botonesNavegacionAnillos = document.getElementsByClassName("boton_navegacion_anillos");

        for (var _i2 = 0; _i2 < botonesNavegacionAnillos.length; _i2 += 1) {
          var _botonesNavegacionItem = botonesNavegacionAnillos[_i2];

          _botonesNavegacionItem.onclick = function recorrepaginas() {
            [].forEach.call(document.querySelectorAll('.breadcrumbs div'), function (el) {
              el.classList.remove('active');
            });
            [].forEach.call(document.querySelectorAll("[data-paso=\"".concat(this.dataset.paso, "\"]")), function (el) {
              el.classList.add('active');
            });
          };
        }

        function consultaTalla() {
          var pais = document.getElementById("pais").value;
          var medidaEnMm = parseFloat(document.getElementById("medida_en_mm_anillo").value);
          var tamanoFinal = 0;
          var keysMedidas = Object.keys(datosMonedas[pais].medida);
          var valorEncontrado = 0.0;
          keysMedidas.forEach(function (key) {
            var medida = parseFloat(key).toFixed(1);

            if (pais === "uk") {
              medida = parseFloat(key).toFixed(2);
            }

            if (medida <= medidaEnMm) {
              if (medida >= valorEncontrado) {
                valorEncontrado = medida;
              }

              tamanoFinal = datosMonedas[pais].medida[valorEncontrado];
            }
          });
          document.getElementById("boton_navegacion_anillos").style.display = "none";
          document.getElementById("boton_final").style.display = "block";
          document.getElementById("tu_talla_es").innerHTML = tamanoFinal;
        }

        function filtraMonedasPorPais(pais) {
          var selectorMonedas = document.getElementById("moneda_seleccionada");

          while (selectorMonedas.options.length > 0) {
            selectorMonedas.remove(0);
          }

          var option = document.createElement("option");
          option.text = lang['Selecciona una moneda'];
          option.value = '';
          selectorMonedas.add(option);
          var keysMonedas = Object.keys(datosMonedas[pais].moneda);
          keysMonedas.forEach(function (key) {
            var medidamoneda = parseFloat(datosMonedas[pais].moneda[key]);

            if (medidamoneda >= 19) {
              option = document.createElement("option");
              option.text = key;
              option.value = datosMonedas[pais].moneda[key];
              selectorMonedas.add(option);
            }
          });
        }

        document.getElementById("pais_seleccionado").onchange = function () {
          filtraMonedasPorPais(document.getElementById("pais_seleccionado").value);
        }; //  filtraMonedasPorPais(document.getElementById("pais_seleccionado").value);


        function controlaSegundoSlider() {
          var v = document.getElementById("slider_anillo").value; // getting

          var target = document.getElementById("slider_anillo");
          var tamano = parseInt(v, 10);
          var tamanoModificador = tamano / 2;
          var elemento = document.getElementById("circulo_anillo");
          var proporcion = parseFloat(document.getElementById("proporcion").value);
          var medidaAnillo = (tamano / proporcion).toFixed(2);
          elemento.style.width = "".concat(tamano, "px");
          elemento.style.height = "".concat(tamano, "px");
          elemento.style.setProperty('top', "calc(50% - ".concat(tamanoModificador, "px"));
          elemento.style.setProperty('left', "calc(50% - ".concat(tamanoModificador, "px")); //    medidaAnillo+=1;

          if (document.getElementById("medida_circulo_anillo_div").offsetWidth > document.getElementById("medida_circulo_anillo").offsetWidth) {
            document.getElementById("medida_circulo_anillo_div").classList.add("nocabe");
          } else {
            document.getElementById("medida_circulo_anillo_div").classList.remove("nocabe");
            document.getElementById("flecha_diametro").style.display = "inline-block";
          }

          if (medidaAnillo !== "NaN") {
            var elementoAnilloDiv = document.getElementById("medida_circulo_anillo_div");

            if (medidaAnillo > medidaEnMmMax) {
              document.getElementById("slider_anillo").max = document.getElementById("slider_anillo").value; //     medidaAnillo=medidaEnMmMax;
            } else {
              var anchoAnillo = elementoAnilloDiv.offsetWidth / 2;
              elementoAnilloDiv.style.setProperty('left', "calc(50% - ".concat(anchoAnillo, "px"));
            }

            document.getElementById('medida_circulo_anillo_div').innerHTML = "".concat(medidaAnillo, "mm");
            document.getElementById('medida_en_mm_anillo').value = medidaAnillo;
          }

          var min = target.min;
          var max = target.max;
          var val = target.value;
          target.style.backgroundSize = "".concat((val - min) * 100 / (max - min), "% 100%");
        }

        function ajustaSegundoSlider() {
          var v = document.getElementById("slider_anillo").value; // getting

          var target = document.getElementById("slider_anillo");
          var tamano = parseInt(v, 10);
          var tamanoModificador = tamano / 2;
          var elemento = document.getElementById("circulo_anillo");
          elemento.style.width = "".concat(tamano, "px");
          elemento.style.height = "".concat(tamano, "px");
          elemento.style.setProperty('top', "calc(50% - ".concat(tamanoModificador, "px"));
          elemento.style.setProperty('left', "calc(50% - ".concat(tamanoModificador, "px"));
          var min = target.min;
          var max = target.max;
          var val = target.value;
          target.style.backgroundSize = "".concat(val * 100 / (max - min), "% 100%");
        }

        function controlaPrimerSlider() {
          var v = document.getElementById("slider").value; // getting

          var target = document.getElementById("slider");
          var tamano = parseFloat(v) + 50;
          var tamanoModificador = tamano / 2;
          var tamanoExterior = parseFloat(v) + 80;
          var tamanoModificadorExterior = tamanoExterior / 2;
          var elemento = document.getElementById("circulo_moneda");
          elemento.style.width = "".concat(tamano, "px");
          elemento.style.height = "".concat(tamano, "px");
          elemento.style.setProperty('top', "calc(50% - ".concat(tamanoModificador, "px"));
          elemento.style.setProperty('left', "calc(50% - ".concat(tamanoModificador, "px"));
          var circuloMonedaExterior = document.getElementById("circulo_moneda_exterior");
          circuloMonedaExterior.style.width = "".concat(tamanoExterior, "px");
          circuloMonedaExterior.style.height = "".concat(tamanoExterior, "px");
          circuloMonedaExterior.style.setProperty('top', "calc(50% - ".concat(tamanoModificadorExterior, "px"));
          circuloMonedaExterior.style.setProperty('left', "calc(50% - ".concat(tamanoModificadorExterior, "px"));
          var min = target.min;
          var max = target.max;
          var val = target.value;
          target.style.backgroundSize = "".concat((val - min) * 100 / (max - min), "% 100%"); //         target.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%'

          var medidaMoneda = parseFloat(document.getElementById("tamano_moneda").value);
          var proporcion = parseFloat(tamano / medidaMoneda);
          document.getElementById("proporcion").value = proporcion;
          document.getElementById("slider_anillo").value = v;
          ajustaSegundoSlider();
          var pais = document.getElementById("pais").value;
          var keysMedidas = Object.keys(datosMonedas[pais].medida);
          keysMedidas.forEach(function (key) {
            var medida = parseFloat(key);

            if (medida <= medidaEnMmMin) {
              medidaEnMmMin = medida;
            }

            if (medida >= medidaEnMmMax) {
              medidaEnMmMax = medida;
            }
          });
          document.getElementById("slider_anillo").min = parseFloat(medidaEnMmMin * proporcion);
          document.getElementById("slider_anillo").max = parseFloat(medidaEnMmMax * proporcion);
        }

        document.getElementById("slider").addEventListener("change", controlaPrimerSlider);
        document.getElementById("slider").addEventListener("input", controlaPrimerSlider);

        document.getElementById("moneda_seleccionada").onchange = function () {
          document.getElementById("tamano_moneda").value = document.getElementById("moneda_seleccionada").value; // getting
        };

        document.getElementById("slider_anillo").addEventListener("change", consultaTalla);
        document.getElementById("slider_anillo").addEventListener("input", controlaSegundoSlider);
        /*
            function controlaPantalla(pantalla){


                [].forEach.call(document.querySelectorAll('.breadcrumbs div'), function (el) {
                    el.classList.remove('active');
                });
                [].forEach.call(document.querySelectorAll(`[data-paso=${pantalla}]`), function (el) {
                    el.classList.add('active');
                });
            }

            document.getElementById("paso_breadcrumb_uno").addEventListener("click", function(){controlaPantalla(1)});
            document.getElementById("paso_breadcrumb_dos").addEventListener("click", function(){controlaPantalla(2)});
            document.getElementById("paso_breadcrumb_tres").addEventListener("click", function(){controlaPantalla(3)});
        */
      }; 